export const menuName = "访问控制";
export const menuList = [
  {
    key: "1",
    title: "概览",
    path: "/dashboard/devops/ram/overview",
    src: require("@/assets/svg/icon/overview.svg"),
    checkedSrc: require("@/assets/svg/icon/overview-checked.svg")
  },
  {
    key: "2",
    title: "用户",
    path: "/dashboard/devops/ram/user",
    src: require("@/assets/svg/icon/user.svg"),
    checkedSrc: require("@/assets/svg/icon/user-checked.svg")
  },
  {
    key: "3",
    title: "角色",
    path: "/dashboard/devops/ram/role",
    src: require("@/assets/svg/icon/role.svg"),
    checkedSrc: require("@/assets/svg/icon/role-checked.svg")
  },
  {
    key: "4",
    title: "用户组",
    path: "/dashboard/devops/ram/user-group",
    src: require("@/assets/svg/icon/user-group.svg"),
    checkedSrc: require("@/assets/svg/icon/user-group-checked.svg")
  }
];

export const USER_TABLE_COLUMNS = [
  {
    title: "序号",
    dataIndex: "index",
    key: "index",
    width: 84
  },
  {
    title: "用户名",
    dataIndex: "name",
    key: "name"
  },
  {
    title: "app ID",
    dataIndex: "appID",
    key: "appID"
  },
  {
    title: "AccessKey",
    dataIndex: "AccessKey",
    key: "AccessKey"
  },
  {
    title: "创建时间",
    dataIndex: "time",
    key: "time"
  }
];
export const USER_GROUP_TABLE_COLUMNS = [
  {
    title: "序号",
    dataIndex: "index",
    key: "index",
    width: 84
  },
  {
    title: "用户组名称",
    dataIndex: "name",
    key: "name"
  },
  {
    title: "备注",
    dataIndex: "remark",
    key: "remark"
  },
  {
    title: "创建时间",
    dataIndex: "time",
    key: "time"
  }
];
